/* MĦABBA: paid greeting cards in cart drawer. Cart Ajax API, €0.50/card. */
(function () {
  'use strict';
  if (window.__mhabbaCartGiftInstalled) return;
  window.__mhabbaCartGiftInstalled = true;

  function route(path) {
    var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return prefix.replace(/\/?$/, '/') + path;
  }
  async function request(path, payload) {
    var options = { credentials: 'same-origin' };
    if (payload !== undefined) {
      options.method = 'POST';
      options.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      options.body = JSON.stringify(payload);
    }
    var response = await fetch(route(path), options);
    var data = await response.json();
    if (!response.ok || data.errors || Number(data.status) >= 400) {
      throw new Error((typeof data.description === 'string' && data.description) ||
        (typeof data.message === 'string' && data.message) ||
        'Could not update the greeting cards. Please check the cart and try again.');
    }
    return data;
  }
  function report(widget, message, isError) {
    var output = widget.querySelector('[data-gift-status]');
    if (output) {
      output.textContent = message || '';
      output.dataset.error = isError ? 'true' : 'false';
      output.hidden = !message;
    }
  }
  function busy(widget, state) {
    widget.querySelectorAll('[data-gift-save], [data-gift-remove]').forEach(function (button) {
      button.disabled = state;
      if (state) {
        button.dataset.originalText = button.textContent;
        button.textContent = 'Saving…';
      } else if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        delete button.dataset.originalText;
      }
    });
  }
  function getLinkedCards(cart, pair) {
    if (!pair) return [];
    return (cart.items || []).filter(function (item) {
      return item.properties && item.properties['_Gift pairing'] === pair &&
        item.properties['_Greeting card'] === 'Yes';
    }).sort(function (a, b) {
      return (Number(a.properties['_Gift unit']) || 0) -
        (Number(b.properties['_Gift unit']) || 0);
    });
  }
  function itemFromCart(cart, key) {
    return (cart.items || []).find(function (entry) { return entry.key === key; });
  }
  function newPairId() {
    var random = Math.random().toString(36).slice(2, 12);
    return 'MH-CART-' + Date.now() + '-' + random;
  }
  function giftProperties(jewellery, pair, index, choice) {
    var p = {
      '_Greeting card': 'Yes',
      '_Gift pairing': pair,
      '_Gift unit': String(index + 1),
      'For jewellery': jewellery.product_title || jewellery.title || 'Jewellery',
      'To': choice.to,
      'From': choice.from
    };
    if (choice.message) p.Message = choice.message;
    return p;
  }
  function collect(widget) {
    var rows = Array.prototype.slice.call(widget.querySelectorAll('[data-gift-entry]'));
    var entries = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var picker = row.querySelector('[data-card-select]');
      var to = row.querySelector('[data-gift-to]');
      var from = row.querySelector('[data-gift-from]');
      var message = row.querySelector('[data-gift-message]');
      var id = Number(picker && picker.value);
      // "No mini greeting card" is a valid gift selection: no €0.50 charge.
      if (!id) { entries.push(null); continue; }
      if (!to.value.trim() || !from.value.trim()) {
        (!to.value.trim() ? to : from).focus();
        throw new Error('Please complete To and From for greeting card ' + (i + 1) + '.');
      }
      entries.push({
        id: id,
        to: to.value.trim(),
        from: from.value.trim(),
        message: (message && message.value || '').trim()
      });
    }
    return entries;
  }
  function updateDisplay(widget) {
    var selectedCount = 0;
    widget.querySelectorAll('[data-gift-entry]').forEach(function (row) {
      var picker = row.querySelector('[data-card-select]');
      var hasCard = !!(picker && picker.value);
      if (hasCard) selectedCount += 1;
      var details = row.querySelector('[data-card-details]');
      if (details) details.hidden = !hasCard;
      var preview = row.querySelector('[data-card-preview]');
      var option = picker && picker.selectedOptions && picker.selectedOptions[0];
      if (preview) {
        var imageUrl = option && option.dataset.cardImage;
        preview.hidden = !imageUrl;
        if (imageUrl) {
          preview.src = imageUrl;
          preview.alt = option.dataset.cardTitle || 'Mini greeting card';
        }
      }
    });
    var total = widget.querySelector('[data-gift-total]');
    if (total) total.textContent = selectedCount ? '· €' + (selectedCount * 0.5).toFixed(2) : '· No card charge';
  }
  async function refresh() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }
  async function updateJewellery(line, pair, isGift) {
    var props = Object.assign({}, line.properties || {});
    if (pair) props['_Gift pairing'] = pair; else delete props['_Gift pairing'];
    if (isGift) props['This is a gift (optional)'] = 'Yes';
    else delete props['This is a gift (optional)'];
    return request('cart/change.js', {
      id: line.key, quantity: line.quantity, properties: props
    });
  }

  async function saveGift(widget, checked, removeOnly) {
    var cart = await request('cart.js');
    var jewellery = itemFromCart(cart, widget.dataset.itemKey);
    if (!jewellery) throw new Error('The cart changed. Close and reopen it to continue.');

    var entries = checked && !removeOnly ? collect(widget) : [];
    if (checked && entries.length !== jewellery.quantity) {
      throw new Error('The item quantity changed. Reopen the cart to personalise your selections.');
    }
    var pair = (jewellery.properties && jewellery.properties['_Gift pairing']) || '';
    var hasSelectedCard = checked && entries.some(function (entry) { return !!entry; });
    var originalCards = getLinkedCards(cart, pair);
    var oldGiftStatus = jewellery.properties && jewellery.properties['This is a gift (optional)'] === 'Yes';

    // Preserve any existing pairing while changing card options, and write the
    // visible gift status to the actual jewellery line for Shopify orders.
    var nextPair = hasSelectedCard ? pair || newPairId() : '';
    if (nextPair !== pair || oldGiftStatus !== checked) {
      await updateJewellery(jewellery, nextPair, checked);
      cart = await request('cart.js');
      jewellery = (cart.items || []).find(function (item) {
        return item.variant_id === jewellery.variant_id && item.properties &&
          item.properties['_Gift pairing'] === nextPair &&
          item.properties['This is a gift (optional)'] === (checked ? 'Yes' : undefined);
      }) || (cart.items || []).find(function (item) {
        return item.key === jewellery.key;
      }) || jewellery;
    }

    // Read card keys from the current cart; Shopify can change keys after property edits.
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i]) continue;
      var selected = entries[i];
      cart = await request('cart.js');
      var existingCards = getLinkedCards(cart, nextPair);
      var oldCard = existingCards.find(function (item) {
        return String(item.properties['_Gift unit']) === String(i + 1);
      });
      if (!oldCard && i === 0) {
        oldCard = existingCards.find(function (item) {
          return !item.properties['_Gift unit'];
        });
      }

      var props = giftProperties(jewellery, nextPair, i, selected);
      if (oldCard && Number(oldCard.variant_id) === selected.id) {
        var mergedProps = Object.assign({}, oldCard.properties || {}, props);
        if (!selected.message) delete mergedProps.Message;
        await request('cart/change.js', {
          id: oldCard.key, quantity: 1, properties: mergedProps
        });
      } else {
        // Charge exactly one real Shopify mini-card item per selected unit.
        await request('cart/add.js', {
          items: [{ id: selected.id, quantity: 1, properties: props }]
        });
        if (oldCard) {
          cart = await request('cart.js');
          var oldCardFresh = itemFromCart(cart, oldCard.key);
          if (oldCardFresh) await request('cart/change.js', { id: oldCardFresh.key, quantity: 0 });
        }
      }
    }

    // Remove only cards that the customer deselected (or all if gift was unchecked).
    // Keep the gift flag when no card is selected, as Luca requested.
    cart = await request('cart.js');
    var cardsToReview = getLinkedCards(cart, nextPair || pair);
    var desiredUnits = new Set(entries.map(function (entry, index) {
      return entry ? String(index + 1) : null;
    }).filter(Boolean));
    var keysToRemove = cardsToReview.filter(function (card) {
      var unit = card.properties['_Gift unit'] || '1';
      return !hasSelectedCard || !desiredUnits.has(String(unit));
    }).map(function (card) { return card.key; });
    for (var j = 0; j < keysToRemove.length; j++) {
      cart = await request('cart.js');
      var found = itemFromCart(cart, keysToRemove[j]);
      if (found) await request('cart/change.js', { id: found.key, quantity: 0 });
    }

    // When the last paid card is removed, eliminate the obsolete pairing ID but
    // intentionally retain "This is a gift (optional): Yes" on gift-only orders.
    if (!hasSelectedCard && pair) {
      cart = await request('cart.js');
      var kept = (cart.items || []).find(function (item) {
        return item.variant_id === jewellery.variant_id && item.properties &&
          item.properties['_Gift pairing'] === pair &&
          item.properties['_Greeting card'] !== 'Yes';
      });
      if (kept) await updateJewellery(kept, '', checked);
    }
    return true;
  }

  async function removeGiftCards(widget) {
    return saveGift(widget, true, true);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-card-select]');
    if (select) {
      var row = select.closest('[data-mhabba-cart-gift]');
      if (row) { updateDisplay(row); report(row, '', false); }
      return;
    }
    if (!event.target.matches('[data-gift-toggle]')) return;
    var checkbox = event.target;
    var widget = checkbox.closest('[data-mhabba-cart-gift]');
    if (!widget) return;
    var panel = widget.querySelector('[data-gift-panel]');
    if (panel) panel.hidden = !checkbox.checked;
    report(widget, '', false);
    // Unchecking reverses saved gift status and removes linked mini-cards;
    // just hiding the form must not leave a paid card behind.
    if (!checkbox.checked && widget.dataset.busy !== 'true') {
      widget.dataset.busy = 'true';
      busy(widget, true);
      saveGift(widget, false, false).then(function () {
        report(widget, 'Gift option removed.', false);
        return refresh();
      }).catch(function (error) {
        checkbox.checked = true;
        if (panel) panel.hidden = false;
        report(widget, error && error.message || 'Unable to remove gift option.', true);
      }).finally(function () {
        widget.dataset.busy = 'false';
        if (widget.isConnected) busy(widget, false);
      });
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-gift-message]')) return;
    var row = event.target.closest('[data-gift-entry]');
    var count = row && row.querySelector('[data-gift-count]');
    if (count) count.textContent = String(event.target.value.length);
  }, true);

  document.addEventListener('click', async function (event) {
    var save = event.target.closest('[data-gift-save]');
    var remove = event.target.closest('[data-gift-remove]');
    if (!save && !remove) return;
    event.preventDefault();
    var widget = (save || remove).closest('[data-mhabba-cart-gift]');
    if (!widget || widget.dataset.busy === 'true') return;
    widget.dataset.busy = 'true';
    busy(widget, true);
    report(widget, '', false);
    try {
      if (remove) await removeGiftCards(widget);
      else await saveGift(widget, !!widget.querySelector('[data-gift-toggle]')?.checked, false);
      report(widget, remove ? 'Mini greeting cards removed. This is still marked as a gift.' : 'Gift preference saved to cart.', false);
      await refresh();
    } catch (error) {
      report(widget, error && error.message || 'Could not update the cart. Please try again.', true);
    } finally {
      widget.dataset.busy = 'false';
      if (widget.isConnected) busy(widget, false);
    }
  }, true);
  // Recompute the optional-card subtotal when the drawer is initially rendered
  // or re-rendered by the theme's Ajax cart refresh.
  document.querySelectorAll('[data-mhabba-cart-gift]').forEach(updateDisplay);
  document.addEventListener('theme:cart:change', function () {
    document.querySelectorAll('[data-mhabba-cart-gift]').forEach(updateDisplay);
  });
})();
